<style lang="scss" src="./CertificadosList.scss"></style>
<template src="./CertificadosList.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Descriptions, DescriptionsItem, Divider} from 'element-ui'
import {requesServelMixin} from "src/api/servelApi"
import {requesCertificadosMixin} from "src/api/certificadosApi"
import ScreenSizeMixin from "src/mixins/ScreenSizeMixin";
import {NotifyMixin} from "src/mixins/NotifyMixin";
import moment from "moment";
import {mapState} from "vuex"

export default {
  name: "CertificadosList",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Divider.name]: Divider,
  },
  data: () => ({
    loading: true,
    errored: false,
    model: {
      rut: "",
      nombrecompleto: "",
      partido_id: "",
      partido_nombre: "",
      categoria_nombre: null,
      categoria_desc: "",
      fecha_respaldo: null,
      fecha_afiliacion: null,
      afiliacion: ""
    },
  }),
  mixins: [
    requesServelMixin,
    requesCertificadosMixin,
    ScreenSizeMixin,
    NotifyMixin
  ],
  beforeMount() {
    this.partidoafiliados();
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    titleCertificado: function () {
      return `Consulta de Afiliación a Partido Político`;
    },
  },
  methods: {
    partidoafiliados() {
      this.loading = true;
      this.getPartidoafiliadosByToken()
        .then(response => {
          this.$log.debug('getPartidoafiliadosByToken', response.data.statusCode);

          if (response.data.statusCode === 200) {
            const data = response.data.datos;
            this.$log.debug(data)

            this.model.rut = this.user.current.rut;
            this.model.nombrecompleto = this.user.current.nombreCompleto.toUpperCase();
            this.model.partido_id = data.partido_id;
            this.model.partido_nombre = data.partido_nombre;
            this.model.categoria_nombre = data.categoria_nombre;
            this.model.categoria_desc = data.categoria_desc;
            this.model.fecha_respaldo = moment(data.fecha_respaldo, "YYYYMMDD").format('DD-MM-YYYY');
            this.model.fecha_afiliacion = moment(data.fecha_afiliacion, "YYYYMMDD").format('DD-MM-YYYY');
            this.model.afiliacion = data.partido_nombre

            this.loading = false
            this.errored = false

            return true
          } else {
            this.model.rut = this.user.current.rut;
            this.model.nombrecompleto = this.user.current.nombreCompleto.toUpperCase();
            this.model.afiliacion = "Sin Afiliación Vigente";
            return true;
          }
        })
        .catch(err => {
          this.$log.fatal('getPartidoafiliadosByToken', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        })
        .finally(() => {
          this.loading = false;
        })
    },
    afiliacionMessageError(statusCode) {
      let message = 'Ocurrió un error inesperado al cargar la afiliación'
      if (statusCode === 404) {
        message = 'Afiliación no existe'
      }
      this.showError(message)
    },
    descargarCertificado() {
      const evento = event;
      evento.preventDefault();
      evento.target.disabled = true;
      evento.target.setAttribute("disabled", "disabled");

      const loading = this.getLoading()

      this.getCertificadoAfiliacion()
        .then(response => {
          this.$log.debug('getCertificadoAfiliacion', response.data.statusCode)
          loading.close()

          if (response.data.statusCode === 200) {
            const data = response.data.datos
            let link = document.createElement('a')
            link.href = `data:application/octet-stream;base64,${data}`
            const date = moment().format('YYYYMMDDhhmmss')
            link.download = `certificado-${date}.pdf`;
            link.click();
          } else if (response.data.statusCode === 404) {
            this.showError('No se encuentra en el registro electoral.')
          } else if (response.data.statusCode === 409) {
            this.showError('No se encuentra afiliado a un partido político.')
          } else {
            this.showError('Ocurrió un error inesperado al cargar el certificado')
          }
        }).catch(err => {
        this.$log.error('Ocurrió un error inesperado al cargar el certificado', err)
        this.showError('Ocurrió un error inesperado al cargar el certificado')
        loading.close()
      })
        .finally(() => {
          evento.target.disabled = false;
          evento.target.removeAttribute("disabled");
        })
    }

  }
}
</script>

<style scoped>

</style>
